"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useMoleculeEditor = void 0;
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
/** @jsxImportSource @emotion/react */
const react_1 = require("react");
const full_1 = require("react-ocl/full");
const ui_1 = require("react-science/ui");
const DispatchContext_1 = require("../context/DispatchContext");
function MoleculeStructureEditorModal(props) {
    const { onClose = () => null, selectedMolecule, floatMoleculeOnSave = false, isOpen = false, } = props;
    const [molfile, setMolfile] = (0, react_1.useState)(null);
    const dispatch = (0, DispatchContext_1.useDispatch)();
    (0, react_1.useEffect)(() => {
        if (selectedMolecule) {
            setMolfile(selectedMolecule.molfile);
        }
        else {
            setMolfile(null);
        }
    }, [selectedMolecule]);
    const cb = (0, react_1.useCallback)((newMolfile, molecule) => {
        if (molecule.getAllAtoms() === 0) {
            setMolfile(null);
        }
        else {
            setMolfile(newMolfile);
        }
    }, [setMolfile]);
    const handleClose = (0, react_1.useCallback)(() => {
        onClose();
    }, [onClose]);
    const handleSave = (0, react_1.useCallback)(() => {
        if (molfile) {
            if (selectedMolecule) {
                const { id, label } = selectedMolecule;
                dispatch({
                    type: 'SET_MOLECULE',
                    payload: {
                        molfile,
                        id,
                        label,
                    },
                });
                onClose('replace');
            }
            else {
                dispatch({
                    type: 'ADD_MOLECULE',
                    payload: {
                        molfile,
                        floatMoleculeOnSave,
                    },
                });
                onClose('new');
            }
        }
    }, [molfile, selectedMolecule, dispatch, floatMoleculeOnSave, onClose]);
    return ((0, jsx_runtime_1.jsx)(ui_1.ConfirmModal, { headerColor: "transparent", isOpen: isOpen, onRequestClose: handleClose, onCancel: handleClose, onConfirm: handleSave, maxWidth: 700, children: (0, jsx_runtime_1.jsx)(ui_1.Modal.Body, { children: (0, jsx_runtime_1.jsx)(full_1.StructureEditor, { initialMolfile: selectedMolecule?.molfile, svgMenu: true, fragment: false, onChange: cb }) }) }));
}
function useMoleculeEditor(floatMoleculeOnSave = false) {
    const [isOpen, openModal, closeModal] = (0, ui_1.useOnOff)(false);
    const [molecule, setMolecule] = (0, react_1.useState)();
    const modal = ((0, jsx_runtime_1.jsx)(MoleculeStructureEditorModal, { selectedMolecule: molecule, floatMoleculeOnSave: floatMoleculeOnSave, onClose: closeModal, isOpen: isOpen }));
    const openMoleculeEditor = (0, react_1.useCallback)((molecule) => {
        setMolecule(molecule);
        openModal();
    }, [openModal]);
    return { modal, openMoleculeEditor };
}
exports.useMoleculeEditor = useMoleculeEditor;
exports.default = MoleculeStructureEditorModal;
